<template>
  <div>
    <el-col>
      <h4 class="h4">
        <i class="el-icon-s-management"></i>&nbsp;&nbsp;稿件信息
      </h4></el-col
    >

    <el-form ref="manuscripts" v-model="manuscripts" label-width="100px">
      <el-form-item label="稿件标题" prop="title">
        <el-input
          v-model="manuscripts.title"
          placeholder="稿件标题"
          size="medium"
        ></el-input>
      </el-form-item>
      <el-form-item label="稿件类型" prop="category">
        <el-select
          style="width: 100%"
          size="medium"
          v-model="manuscripts.category"
          placeholder="请选择类型"
        >
          <el-option label="生理实验" value="生理实验"></el-option>
          <el-option label="声学实验" value="声学实验"></el-option>
          <el-option label="心理实验" value="心理实验"></el-option>
          <el-option label="神经科学" value="神经科学"></el-option>
          <el-option label="建模仿真" value="建模仿真"></el-option>
          <el-option label="理论探索" value="理论探索"></el-option>
          <el-option label="评述推介" value="评述推介"></el-option>
          <el-option label="学术资讯" value="学术资讯"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="摘要" prop="abstracts">
        <el-input
          type="textarea"
          placeholder="稿件摘要"
          :rows="15"
          v-model="manuscripts.abstracts"
          size="medium"
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词" prop="manuscriptKeywords">
        <el-input
          type="textarea"
          placeholder="稿件关键词"
          :rows="5"
          v-model="manuscripts.manuscriptKeywords"
          size="medium"
        ></el-input>
      </el-form-item>
    </el-form>

    <el-row></el-row>
    <br/>
    <el-col class="h4">
      <el-button class="save" @click="ts()">保存</el-button>
    </el-col>
  </div>
</template>

<script>
import {
  tsManuscriptInfo,
  getTsManuscriptInfo,
  getManuscriptsChargeInfo
} from '@/api/data'

export default {
  name: 'ManuscriptInfoComponent',
  props: {
    info: {
      default: '',
      // 如果传递过来的值不符合此类型，则会在终端报错
      type: String
    }
  },

  data() {
    return {
      flag: 0,
      userInfo: null,
      manuscripts: {
        title: '', // 稿件标题
        category: '', // 稿件类型
        abstracts: '', // 摘要
        address: '', // 文件地址
        content: '', // 文件内容
        manuscriptGroup: '稿件投递', // 哪一组
        mauscriptKeywords: '', // 关键词
        period: '第1期' // 哪一期
      }
    }
  },

  methods: {
    initModeification() {
      let flag = this.$route.query.flag
      if (flag == null) {
        return
      }
      getManuscriptsChargeInfo({
        manuscriptFlag: flag
      }).then((res) => {
        console.log(res)
        let oldManuscript = res.data.result.newest.manuscript
        if (
          oldManuscript.manuscriptStatus != 'refuse' &&
          oldManuscript.manuscriptStatus != 'second_refuse'
        ) {
          this.$message.error('稿件审批未完成，请勿重新上传')
          this.$router.replace('/index')
        }
        this.manuscripts.flag = flag
        this.manuscripts.title = oldManuscript.title
        this.manuscripts.category = oldManuscript.category
        this.manuscripts.abstracts = oldManuscript.abstracts
        this.manuscripts.manuscriptKeywords = oldManuscript.manuscriptKeywords
        this.authorsInfo = oldManuscript.authorInfo
      })
    },
    ts() {
      console.log(this.manuscripts)
      if (this.manuscripts.title === '' && this.manuscripts.category === '' && this.manuscripts.abstracts === '' && this.manuscripts.mauscriptKeywords === '') {
        this.$message({
          message: '有未填写信息',
          type: 'error'
        })
        return
      }
      tsManuscriptInfo({
        key: this.userInfo.email,
        manuscriptInfo: this.manuscripts
      }).then((res) => {
        if (res.data.result == true) {
          this.$message({
            message: '稿件信息已保存',
            type: 'success'
          })
        } else {
          this.$message({
            message: '稿件信息保存有误',
            type: 'error'
          })
        }
      })
    },
    getTs() {
      getTsManuscriptInfo({
        key: this.userInfo.email
      }).then((res) => {
        // console.log('this.manuscripts' + res.data.result.manuscriptInfo.title)
        if (res.data.result.manuscriptInfo != null) {
          this.manuscripts = res.data.result.manuscriptInfo
          if (this.manuscripts.category === '选择稿件类型') {
            this.manuscripts.category = ''
          }
        }
      })
    }
  },
  mounted() {
    let userInfo = this.$cookie.getCookie('userInfo')
    // if (userInfo == null || userInfo.type != "投稿人") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }
    this.userInfo = userInfo
    this.getTs()
    this.initModeification()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}

.ts {
  width: 150px;
  border-color: #12696e;
  border-width: 1px;
  border-radius: 0px;
}

.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}

button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/manuscriptInfoComponent.vue